import {DeviceOrientation} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/component/viewport/viewportLayout/DeviceOrientation';
import {AString} from '@mintdata/mint-kit/api/values/AString';
import {AStringEnum} from '@mintdata/mint-kit/api/values/AStringEnum';

export class MobileDevice extends AStringEnum
{
    public constructor(value:AString)
    {
        super(value, MobileDevice.availableValues);
    }

    public toString():string
    {
        return this.value ? this.value.toString() : null;
    }

    public static MOBILE = new AString('Mobile');
    public static IPHONE_8 = new AString('iPhone 8');
    public static IPHONE_8_PLUS = new AString('iPhone 8 Plus');
    public static IPHONE_SE = new AString('iPhone SE');
    public static IPHONE_11_PRO = new AString('iPhone 11 Pro');
    public static IPHONE_11 = new AString('iPhone 11');
    public static IPHONE_11_PRO_MAX = new AString('iPhone 11 Pro Max');
    public static ANDROID = new AString('Android');
    public static PIXEL_2 = new AString('Pixel 2');
    public static PIXEL_2_XL = new AString('Pixel 2 XL');
    public static PIXEL_3 = new AString('Pixel 3');
    public static PIXEL_3_XL = new AString('Pixel 3 XL');
    public static PIXEL_S10E = new AString('Galaxy S10e');
    public static PIXEL_S10 = new AString('Galaxy S10');
    public static PIXEL_S10PLUS = new AString('Galaxy S10+');

    public static availableValues:Array<AString> = [
        MobileDevice.MOBILE,
        MobileDevice.IPHONE_8,
        MobileDevice.IPHONE_8_PLUS,
        MobileDevice.IPHONE_SE,
        MobileDevice.IPHONE_11_PRO,
        MobileDevice.IPHONE_11,
        MobileDevice.IPHONE_11_PRO_MAX,
        MobileDevice.ANDROID,
        MobileDevice.PIXEL_2,
        MobileDevice.PIXEL_2_XL,
        MobileDevice.PIXEL_3,
        MobileDevice.PIXEL_3_XL,
        MobileDevice.PIXEL_S10E,
        MobileDevice.PIXEL_S10,
        MobileDevice.PIXEL_S10PLUS
    ];

    public static mobile():MobileDevice
    {
        return new MobileDevice(MobileDevice.MOBILE);
    }

    public static iPhone8():MobileDevice
    {
        return new MobileDevice(MobileDevice.IPHONE_8);
    }

    public static iPhone8Plus():MobileDevice
    {
        return new MobileDevice(MobileDevice.IPHONE_8_PLUS);
    }

    public static iPhoneSE():MobileDevice
    {
        return new MobileDevice(MobileDevice.IPHONE_SE);
    }

    public static iPhone11Pro():MobileDevice
    {
        return new MobileDevice(MobileDevice.IPHONE_11_PRO);
    }

    public static iPhone11():MobileDevice
    {
        return new MobileDevice(MobileDevice.IPHONE_11);
    }

    public static iPhone11ProMax():MobileDevice
    {
        return new MobileDevice(MobileDevice.IPHONE_11_PRO_MAX);
    }

    public static android():MobileDevice
    {
        return new MobileDevice(MobileDevice.ANDROID);
    }

    public static pixel2():MobileDevice
    {
        return new MobileDevice(MobileDevice.PIXEL_2);
    }

    public static pixel2XL():MobileDevice
    {
        return new MobileDevice(MobileDevice.PIXEL_2_XL);
    }

    public static pixel3():MobileDevice
    {
        return new MobileDevice(MobileDevice.PIXEL_3);
    }

    public static pixel3XL():MobileDevice
    {
        return new MobileDevice(MobileDevice.PIXEL_3_XL);
    }

    public static pixelS10E():MobileDevice
    {
        return new MobileDevice(MobileDevice.PIXEL_S10E);
    }

    public static pixelS10():MobileDevice
    {
        return new MobileDevice(MobileDevice.PIXEL_S10);
    }

    public static pixelS10Plus():MobileDevice
    {
        return new MobileDevice(MobileDevice.PIXEL_S10PLUS);
    }

    public static fromString(value:string):MobileDevice
    {
        return new MobileDevice(AString.fromString(value));
    }

    public static getSize(value:AString, orientation:DeviceOrientation):{width:number; height:number}
    {
        let width:number;
        let height:number;

        switch( value.toString() )
        {
            case MobileDevice.MOBILE.toString():
            {
                width = 320;
                height = 568;
                break;
            }

            case MobileDevice.IPHONE_8.toString():
            {
                width = 375;
                height = 667;
                break;
            }

            case MobileDevice.IPHONE_8_PLUS.toString():
            {
                width = 414;
                height = 736;
                break;
            }

            case MobileDevice.IPHONE_SE.toString():
            {
                width = 320;
                height = 568;
                break;
            }

            case MobileDevice.IPHONE_11_PRO.toString():
            {
                width = 375;
                height = 812;
                break;
            }

            case MobileDevice.IPHONE_11.toString():
            case MobileDevice.IPHONE_11_PRO_MAX.toString():
            {
                width = 414;
                height = 896;
                break;
            }

            case MobileDevice.ANDROID.toString():
            {
                width = 360;
                height = 640;
                break;
            }

            case MobileDevice.PIXEL_2.toString():
            {
                width = 412;
                height = 732;
                break;
            }

            case MobileDevice.PIXEL_2_XL.toString():
            case MobileDevice.PIXEL_3.toString():
            {
                width = 360;
                height = 720;
                break;
            }

            case MobileDevice.PIXEL_3_XL.toString():
            {
                width = 360;
                height = 740;
                break;
            }

            case MobileDevice.PIXEL_S10E.toString():
            case MobileDevice.PIXEL_S10.toString():
            case MobileDevice.PIXEL_S10PLUS.toString():
            {
                width = 360;
                height = 760;
                break;
            }
        }

        return orientation.isEqualTo(DeviceOrientation.vertical()) ? {width, height} : {width: height, height: width};
    }
}
